window.HSUI = window.HSUI || {};

document.addEventListener("DOMContentLoaded", () => {
	if (!document.body.classList.contains("hs-login-enabled")) return;
	const language = (document.documentElement.lang || "en").toLowerCase().split("-")[0];
	const rtlLanguages = new Set(["ar", "fa", "he", "ps", "ur"]);
	document.documentElement.dir = rtlLanguages.has(language) ? "rtl" : "ltr";
	document.documentElement.dataset.hsUi = "1";
	document.documentElement.dataset.hsLogin = "1";
});
